import * as React from "react";
import { useRef, useState, useEffect } from "react";
import { APINames } from "../../../../../../legacy/api/api.names";
import { throttle } from "../../../../../../v2/utils/";
import { E2EIdentifier } from "../../../../../e2e/E2EIdentifier";
import { StyledKeypadButton } from "../Buttons";
import { VolumeSlider } from "../VolumeSlider/VolumeSlider";
import { SoundButtonWrapper } from "../Wrappers.Default";

export interface ISoundButtonViewProps {
  muted: boolean;
  soundButtonDisabled: boolean;
  volume: number;
  triggerMuteChangeRequest(mute: boolean): void;
  triggerVolumeChangeRequest(volume: number): void;
}

export function SoundButtonView({
  muted,
  volume,
  soundButtonDisabled,
  triggerVolumeChangeRequest,
  triggerMuteChangeRequest
}: ISoundButtonViewProps) {
  const [visible, setVisible] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [localVolume, setLocalVolume] = useState(volume);

  const triggerVolumeChangeRequestThrottled = useRef(
    throttle(triggerVolumeChangeRequest, 250)
  );

  const onChange = (value: number) => {
    if (value === localVolume) {
      return;
    }

    setLocalVolume(value);
    triggerVolumeChangeRequestThrottled.current([value]);
  };

  const onMouseEnter = () => setVisible(true);
  const onMouseLeave = () => {
    if (isDragging) {
      setIsDragging(false);
      onChange(localVolume);
    }

    setVisible(false);
  };

  useEffect(() => {
    setLocalVolume(volume);
  }, [volume]);

  return (
    <SoundButtonWrapper onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <StyledKeypadButton
        apiName={APINames.SOUND_BUTTON}
        data-e2e-id={E2EIdentifier.DEFAULT_KEYPAD_MUTE_BUTTON}
        type="sound"
        active={!muted}
        onClick={!soundButtonDisabled && triggerMuteChangeRequest(!muted)}
        disabled={soundButtonDisabled}
      />
      {!soundButtonDisabled && (
        <VolumeSlider
          onChange={onChange}
          volume={localVolume}
          muted={muted}
          visible={visible}
          isDragging={isDragging}
          setIsDragging={setIsDragging}
        />
      )}
    </SoundButtonWrapper>
  );
}
